var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncidLogIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4126_59072)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.01664C0 0.455453 0.453074 0 1.01133 0H23.9361C24.4943 0 24.9474 0.455453 24.9474 1.01664C24.9474 1.57782 24.4943 2.03327 23.9361 2.03327H1.01133C0.453074 2.03327 0 1.57782 0 1.01664ZM0 7.79556C0 7.23438 0.453074 6.77893 1.01133 6.77893H9.10194C9.66019 6.77893 10.1133 7.23438 10.1133 7.79556C10.1133 8.35675 9.66019 8.8122 9.10194 8.8122H1.01133C0.453074 8.8122 0 8.35675 0 7.79556ZM0 14.5704C0 14.0092 0.453074 13.5538 1.01133 13.5538H10.449C11.0073 13.5538 11.4604 14.0092 11.4604 14.5704C11.4604 15.1316 11.0073 15.5871 10.449 15.5871H1.01133C0.453074 15.5871 0 15.1316 0 14.5704Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7331 17.3362C17.0745 17.3362 15.5131 16.6855 14.3399 15.5062C13.1668 14.3269 12.5195 12.7572 12.5195 11.09C12.5195 9.42268 13.1668 7.85299 14.3399 6.67369C15.5131 5.4944 17.0745 4.84375 18.7331 4.84375C20.3917 4.84375 21.9532 5.4944 23.1263 6.67369C24.2995 7.85299 24.9467 9.42268 24.9467 11.09C24.9467 12.7572 24.2995 14.3269 23.1263 15.5062C21.9532 16.6855 20.3917 17.3362 18.7331 17.3362ZM18.7331 5.94172C15.9095 5.94172 13.6077 8.25151 13.6077 11.094C13.6077 13.9365 15.9055 16.2463 18.7331 16.2463C21.5608 16.2463 23.8585 13.9365 23.8585 11.094C23.8585 8.25151 21.5608 5.94172 18.7331 5.94172ZM18.7331 14.8068C18.4338 14.8068 18.187 14.5628 18.187 14.2578V14.2497C18.187 13.9487 18.4297 13.7007 18.7331 13.7007C19.0365 13.7007 19.2792 13.9447 19.2792 14.2497V14.2578C19.2792 14.5587 19.0365 14.8068 18.7331 14.8068ZM18.7331 12.9036C18.4338 12.9036 18.187 12.6596 18.187 12.3547V7.92212C18.187 7.6212 18.4297 7.37314 18.7331 7.37314C19.0365 7.37314 19.2792 7.61713 19.2792 7.92212V12.3547C19.2792 12.6556 19.0365 12.9036 18.7331 12.9036Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0449219 20.9541C0.0449219 20.393 0.497996 19.9375 1.05625 19.9375H23.981C24.5393 19.9375 24.9923 20.393 24.9923 20.9541C24.9923 21.5153 24.5393 21.9708 23.981 21.9708H1.05625C0.497996 21.9708 0.0449219 21.5153 0.0449219 20.9541Z",
    fill: "#3D3C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4126_59072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidLogIcon);
export default __webpack_public_path__ + "static/media/incid_log-icon.745ad0878f58db7a5fdc8265fb5a5f17.svg";
export { ForwardRef as ReactComponent };